import type { Distance } from "@pdfking/math"
import { ZERO_DISTANCE } from "@pdfking/math/constants"
import { PlotFunction } from "@pdfking/renderer-api"
import type { PageShape } from "@pdfking/renderer-api"

import type { ShapeSequence } from "#internal"
import type { BoxPointLists } from "#internal"

import { BoxPath } from "./BoxPath"
import { TranslatePoints } from "./TranslatePoints"

export function* PlotPointsList(
  points_list: BoxPointLists,
  layer: string,
  {
    offset_x = ZERO_DISTANCE,
    offset_y = ZERO_DISTANCE,
    closed = false,
  }: {
    offset_x?: Distance
    offset_y?: Distance
    closed?: boolean
  } = {}
): ShapeSequence {
  for (const points of TranslatePoints(-offset_x as Distance, -offset_y as Distance, points_list)) {
    yield {
      enum: PlotFunction.PLOT_PATH,
      points: BoxPath(points),
      stroke_color: layer,
      ...(closed ? { closed: true } : {}),
    } as PageShape
  }
}
